import React from 'react'
import {
	Button,
	ButtonGroup,
	FormGroup,
	FormInput,
	FormLabel,
	FormSelect,
	FormTextarea,
} from './FormComponents.styles'

interface FormGroupProps {
	label: string
	htmlFor?: string
	children: React.ReactNode
}

export const FormGroupComponent: React.FC<FormGroupProps> = ({ label, htmlFor, children }) => (
	<FormGroup>
		<FormLabel htmlFor={htmlFor}>{label}</FormLabel>
		{children}
	</FormGroup>
)

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label: string
	htmlFor?: string
}

export const FormInputComponent: React.FC<FormInputProps> = ({ label, htmlFor, ...props }) => (
	<FormGroupComponent label={label} htmlFor={htmlFor}>
		<FormInput {...props} />
	</FormGroupComponent>
)

interface FormTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label: string
	htmlFor?: string
}

export const FormTextareaComponent: React.FC<FormTextareaProps> = ({ label, htmlFor, ...props }) => (
	<FormGroupComponent label={label} htmlFor={htmlFor}>
		<FormTextarea {...props} />
	</FormGroupComponent>
)

interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
	label: string
	htmlFor?: string
}

export const FormSelectComponent: React.FC<FormSelectProps> = ({ label, htmlFor, ...props }) => (
	<FormGroupComponent label={label} htmlFor={htmlFor}>
		<FormSelect {...props} />
	</FormGroupComponent>
)

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: 'primary' | 'secondary' | 'danger'
	children: React.ReactNode
}

export const ButtonComponent: React.FC<ButtonProps> = ({ variant = 'secondary', children, ...props }) => (
	<Button variant={variant} {...props}>
		{children}
	</Button>
)

interface ButtonGroupProps {
	children: React.ReactNode
	align?: 'left' | 'center' | 'right'
}

export const ButtonGroupComponent: React.FC<ButtonGroupProps> = ({ children, align = 'right' }) => (
	<ButtonGroup align={align}>{children}</ButtonGroup>
)
